import React from "react";
import { default as PEHSlider } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Slider({
  sliders,
  slidesToShow = 1,
  autoplaySpeed = 5000,
  responsive,
}) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed,
    lazyLoad: "progressive",
    responsive: responsive && [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <PEHSlider {...settings}>
      {sliders.length &&
        sliders.map((slide, index) => <div key={index}>{slide}</div>)}
    </PEHSlider>
  );
}

export default Slider;
